module.exports = __webpack_public_path__ + "img/DK221.34d08a4d.png";